import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ActionButton from '@app/components/ui/buttons/ActionButton'

const Restart = (props) => {
  const { boundStudentActions, participate: { starting } } = props

  return (
    <Fragment>
      <p className="paragraph black text-center">
        { window.COUNTRY === 'RU' ? (
            'В связи с техническими неполадками был ограничен доступ  к олимпиаде 13 ноября с 15:00 до 20:00 по московскому времени.'
          ) : (
            I18n.t('students.restart.timeline')
          )
        }
      </p>
      <p className="paragraph black text-center">
        { I18n.t('students.restart.message') }
      </p>
      <div className="text-center">
        <ActionButton
          className="btn btn--red btn--md mt-1 mb-2"
          onClick={
            (e) => boundStudentActions.restartOlypiad({ tour: 'main' })
          }
          disabled={starting}
          loading={starting}>
          { I18n.t('students.restart.continue') }
        </ActionButton>
      </div>
    </Fragment>
  )
}

Restart.propTypes = {
  boundStudentActions: PropTypes.object.isRequired,
  participate: PropTypes.object.isRequired
}

export default Restart
